import React from "react";
import "./Frendao.sass";
import frendao from "./../../../assets/images/halls-kek.png";

export default function Frendao() {
  return (
    <div className="frendao">
      <div className="frendao-bg">
        <div className="frendao-container">
          <h2 className="frendao-title">THE FRENDAO</h2>
          <h2 className="frendao-extra">
            FROGGODS <br /> <br /> 17 FRENDAO LEADERS
          </h2>
          <h3 className="frendao-description">
            The FenDAO will operate as both the Governmental Body and Central
            Bank for the OnlyFrens Ecosystem. They will be entrusted with
            responsibilities that include operating under the following
            guidelines:{" "}
          </h3>
          <div className="frendao-traits-1">
            <ul>
              <li>Consist of FrogGods & DemiGods</li>
              <li>
                Votes on the next human injustice that the Frens will fight
                against{" "}
              </li>
              <li>Verify Change.org petition </li>
            </ul>
          </div>
          <div className="frendao-traits-2">
            <ul>
              <li>Verify Winners’ List and Declare War Heroes</li>
              <li>Confirm $TENDIEs distribution</li>
              <li>Paid for their participation</li>
            </ul>
          </div>
          <div className="frendao-image">
            <img src={frendao} alt="frendao" />
          </div>
        </div>
      </div>
    </div>
  );
}
